
import Confirm from '@/components/confirm/confirm.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'actvDetail',
directives: {
TransferDom
},
components: {
'Confirm': Confirm,
Popup,
Swiper,
Group,
XTextarea
},
data () {
return {
listIndex: 0,
baseList: [{ img: '' }],
isshowall: true,
bannerIndex: 1,
tabIndex: 1,
isConfirmshow: false,
refuseModel: false,
refuseReason: '',
confirmtitle: '',
confirmconten: '',
item: { tribeVo: { imageUrl: '' } },
handleType: '',
position: {},
offset: ''
}
},
created () {
this.getDetail()
},
methods: {
onIndexChange (index) {
this.listIndex = index
},
getDetail () {
var _this = this
var params = new URLSearchParams()
params.append('activityId', this.$route.query.activityId)
params.append('orderId', this.$route.query.orderid)
this.$http({
method: 'post',
url: '/workorder/activity/detail',
params: params
}).then(res => {
this.item = res.result
this.baseList = []
res.result.activityImgSet.forEach(function (element) {
_this.baseList.push({ img: element })
})
this.position = { lng: this.item.addressLongitude, lat: this.item.addressLatitude }
let labelwidth = -(((12 * this.item.address.length + 28) / 2) - 15)
this.offset = { width: labelwidth, height: '-35' }
}).catch(error => {
console.log(error)
})
},
confirm () {
var params = new URLSearchParams()
params.append('orderid', this.$route.query.orderid)
if (this.handleType === 1) {
this.$http({
method: 'post',
url: '/workorder/activity/passcheck',
params: params
}).then(res => {
this.$vux.toast.text('操作成功，活动审核已通过')
let source = localStorage.getItem('school_source') || '' 
if (source === 'v1') {
this.$router.push({ path: '/todoPage' })
} else if (source === 'v2') {
this.$router.push({ path: '/v2todoPage' })
}
}).catch(error => {
console.log(error)
})
} else {
params.append('remarks', this.refuseReason)
this.$http({
method: 'post',
url: '/workorder/activity/rejectcheck',
params: params
}).then(res => {
this.$vux.toast.text('操作成功，活动审核已驳回')
let source = localStorage.getItem('school_source') || '' 
if (source === 'v1') {
this.$router.push({ path: '/todoPage' })
} else if (source === 'v2') {
this.$router.push({ path: '/v2todoPage' })
}
}).catch(error => {
console.log(error)
})
}
},
handleswipe (type) {
this.handleType = type
switch (type) {
case 1:
this.confirmtitle = '通过活动审核'
this.confirmconten = '是否确认通过该活动的发布审核'
this.isConfirmshow = true
break
case 2:
if (this.refuseReason === '') {
this.$vux.toast.text('请输入您的活动审核理由')
} else {
this.confirmtitle = '驳回活动审核'
this.confirmconten = '是否确认驳回该活动的发布审核？'
this.isConfirmshow = true
}
break
}
}
}
}




// WEBPACK FOOTER //
// ./src/components/actvDetail/actvDetail.vue